import "./App.css";
import { Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useState } from "react";
import RiponSong from "./test.mp3";

const dialogues = [
  {
    dialogue: ["আমি মিষ্টি তুমি দই", "দিব প্রেম যাও কই"],
  },
  {
    dialogue: [
      "চালে ধরে চাল কুমড়া",
      "বেড়ায় ধরে কদু",
      "আমি যকন দাদা হব",
      "তুমি হবে দাদু",
    ],
  },
  {
    dialogue: [
      "মাতার উপর ফ্যান ঘুরে",
      "ফেনের উপর সিলিং",
      "বন্দু তুমার বালবাসায়",
      "নাই কোন ফিলিং",
    ],
  },
  {
    dialogue: [
      "ডাবের ভেতর মিষ্টি পানি",
      "তেতুল হইলো টক",
      "বন্ধু তোমায় জানাই আমি",
      "ঈদ মোবারক",
    ],
  },
  {
    dialogue: [
      "বিরাল কায় মাছের কাটা",
      "আমি কাই জুশ",
      "মেকাপ ছারা তোমায় দেকলে",
      "তাকেনা আমার হুশ",
    ],
  },
  {
    dialogue: [
      "মনের দুক্কে বন্দু আমি",
      "খাচ্চি এখন কলা",
      "তুমার কথা মনে হলে",
      "বুকে লাগে জালা",
    ],
  },
  {
    dialogue: [
      "সকালে উঠিয়া আমি",
      "জোরে জোরে বলি",
      "তাড়াতাড়ি পাই যেন",
      "বউ আর শালী",
    ],
  },
  {
    dialogue: ["আকাশের তারা বাগানের ফুল", "বাড়ির পাশে প্রেম করাটা ভুল"],
  },
  {
    dialogue: [
      "প্লাজু হয় ঢিলাঢালা",
      "প্যান্ট হয় টাইট",
      "এখন আমি ঘুমাতে যাবো",
      "সবাইকে গুড নাইট",
    ],
  },
  {
    dialogue: [
      "আসচে ঈদ চলছে গাড়ি",
      "বন্দু তুমি দাওয়াত দিলে",
      "জাইতাম তুমার বাড়ি",
    ],
  },
  {
    dialogue: [
      "আম যদি মিষ্টি হয়",
      "আপেল হয় গোল",
      "তুমার প্রেমে পইরা আমি",
      "করছি অনেক ভুল",
    ],
  },
  {
    dialogue: ["সকালে উটিয়া আমি মনে মনে বলি", "সারাদিন আমি তুমায় বালবেসে চলি"],
  },
  {
    dialogue: ["সাগরে আছে ডেউ", "আমার নাই কেউ"],
  },
  {
    dialogue: [
      "নদির বুকে উরে বেরায়",
      "সাদা কালো চিল",
      "সিঙ্গেল জীবনে আছে বন্দু",
      "সর্গ সুখের ফিল",
    ],
  },
  {
    dialogue: [
      "তরকারিতে ঝাল হয়েছে",
      "ফেলে দিছি বাটি",
      "তোমার সাথে প্রেম করে",
      "জীবন আমার মাটি",
    ],
  },
  {
    dialogue: [
      "রাতে আমার একা লাগে",
      "পাশে নাই কেউ",
      "বিয়ে করব কবে আমি",
      "উঠছে মনে ঢেউ",
    ],
  },
  {
    dialogue: [
      "কুমিল্লার রসমালাই",
      "বিক্রমপুরের মিষ্টি",
      "তোমার সাথে ভিজবো আমি",
      "যখন হবে বৃষ্টি",
    ],
  },
  {
    dialogue: [
      "চালে ধরে চাল কুমড়া",
      "বেড়ায় ধরে কদু",
      "তুমি যখন বর হবে",
      "আমি হবো বধু",
    ],
  },
  {
    dialogue: ["আমি নারকেল তুমি ডাব", "পাত্তা দেইনা তুমার ভাব"],
  },
  {
    dialogue: [
      "আম মিষ্টি জাম মিষ্টি",
      "চুক্কার দিন শেষ",
      "বন্ধু তুমায় ছ্যাকা দিয়ে",
      "হইছি দরবেশ",
    ],
  },
  {
    dialogue: [
      "টোটে তোমার লিপিষ্টিক",
      "গালে তোমার মেকাপ",
      "আর একবার মিসকল দিলে",
      "করে দিব বেকাপ",
    ],
  },
  {
    dialogue: ["হে এটাই আমি", "যদি তুমি রাজি তাক", "হব তুমার সামি"],
  },
  {
    dialogue: [
      "রাজশাহীর আম ভালো",
      "মহেসখালির পান",
      "এখন অনেক রাত হইছে",
      "ঘুমিয়ে যাও জান",
    ],
  },
  {
    dialogue: [
      "আতা গাছে তোতা পাখি",
      "ডালিম গাছে মউ",
      "তুমাকে আমি বানিয়ে নেব",
      "আমার ঘরের বউ",
    ],
  },
  {
    dialogue: [
      "অল্প অল্প মেঘ থেকে",
      "ঝরে পরে বৃষ্টি",
      "একটু একটু কথা থেকে",
      "ভালবাসার সৃষ্টি",
    ],
  },
  {
    dialogue: [
      "দেকতে ভীষণ ভালো লাগে",
      "সুন্দর তুমার হাসি",
      "তোমায় নিয়ে বটতলায়",
      "বাজাবো আমি বাশি",
    ],
  },
  {
    dialogue: [
      "তুমি যদি আমর হও",
      "আমি হব তুমার",
      "প্রেম নদীতে সাতার দিব",
      "যদি আসে জোয়ার",
    ],
  },
  {
    dialogue: [
      "আগে যদি জানতাম বন্দু",
      "দিবা তুমি চেকা",
      "লাত্তি মাইরা তুমায় আমি",
      "কইরা দিতাম বেকা",
    ],
  },
  {
    dialogue: [
      "জোসনা রাতে তোমায় নিয়ে",
      "দেখবো আমি চাদ",
      "তুমার হাতে হাত রেকে",
      "মারব আমি পাদ",
    ],
  },
  {
    dialogue: [
      "ভালবাসার কথা",
      "তুমি কইও গোপনে",
      "আজকে রাতে বন্ধু",
      "তুমি আইয়ো শপনে",
    ],
  },
  {
    dialogue: [
      "তুমি ধনুক আমি তির",
     "তোমার মনে অনেক ভিড়"],
  },
  {
    dialogue: [
      "আকাশেতে মেঘ জমেচে",
      "করছে ভুম ভুম",
      "বন্দু তুমার চিন্তায় আমার",
      "আসেনা রাতে ঘুম",
    ],
  },
  {
    dialogue: [
      "পানির নিচে মাচ তাকে",
      "মনের বিতর তুমি",
      "ভালবাসি তুমায় আমি",
      "হব তুমার স্বামী",
    ],
  },
  {
    dialogue: ["বাচার মত বাচতে চাই", "আমার একটা তুমি চাই"],
  },
  {
    dialogue: [
      "পদ্দা নদির মাঝি আমি",
      "মনে অনেক ঢেউ",
      "বাড়িতে তুমি কইয়া দিও",
      "আমার লাগবো বউ",
    ],
  },
  {
    dialogue: [
      "আকাশেতে তারা উটে",
      "যায়না তারে ছুয়া",
      "ভালোবেসে তুমায় আমি",
      "করবো ঘরের বুয়া",
    ],
  },
  {
    dialogue: [
      "হলুদ শাড়ি সবুজ বনে",
      "হাটচ কেবল উদাস মনে",
      "বাসব ভাল তুমায় আমি",
      "দেখলে দেকুক হাজার জনে",
    ],
  },
  {
    dialogue: [
      "রিলেশন ছাড়া নাকি দুনিয়া চলে না",
      "তাহলে আমি কি দুনিয়ার বাইরে থাকি",
    ],
  },
  {
    dialogue: ["উপরে আকাশ নিচে বই", "ঈদ গেলো সালামি কই"],
  },
  {
    dialogue: [
      "টমাটু লাল কাচা মরিচ ঝাল",
      "বন্ধু তোমার বুকে",
      "আমায় রাইখো চিরকাল",
    ],
  },
  {
    dialogue: [
      "আমি যদি টিচার হই",
      "তুমি হবে ছাত্রী",
      "এখন আমি ঘুমাতে যাব",
      "সবাইকে শুভ রাত্রী",
    ],
  },
  {
    dialogue: ["নাকের ফুল কানের ফুল", "বালবেসে করলাম ভুল"],
  },
  {
    dialogue: [
      "মুক্তা গাছার মন্ডা ভালো",
      "নেত্রকোনার বালিশ",
      "প্রেম কইরা ছেকা দিলে",
      "বসাইয়া দিব সালিস",
    ],
  },
  {
    dialogue: [
      "বন্ধুর বাড়ির ফুল বাগানে",
      "ফুল ফুটবে কবে",
      "তুমি আমার গার্লফ্রেন্ড",
      "বিয়ে করবে কবে",
    ],
  },
  {
    dialogue: [
      "তুমি যদি চা হও",
      "আমি হব চিনি",
      "এক কাপে মিশব দুজন",
      "তুমি আর আমি",
    ],
  },
  {
    dialogue: [
      "তুমি যদি পায়েশ হও",
      "আমি হব শেমাই",
      "ভালো যদি বাস তুমি",
      "হব তুমার জামাই",
    ],
  },
  {
    dialogue: ["আমি যদি চিনি হই তুমি হবে দই", "এক সাথে মিলেমিশে করবো হৈই ছৈই"],
  },
  {
    dialogue: ["গাভীর পেটে বাছুর", "তোমার আব্বু আমার শশুর"],
  },
];

function App() {
  const [random, setRandom] = useState(0);
  const [isFirstPlay, setFirstPlay] = useState("true");

  // const trimDialogue = (dialogue) => {
  //   return trimDialogue.split(",").join("\n");
  // };
  // var song_source;

  const playSong = () => {
  let song = new Audio(RiponSong);
  // song_source = song.src; // Removed unused assignment
  console.log("PlaySong Called");
  song.play();
  song.volume = 0.5;
  console.log("Playing");
  };



  // let isFirstTime = true; // Removed unused variable
  const getRandomDialogue = () => {
    if (isFirstPlay) {
      playSong();
    }
    setFirstPlay(false);
    let dialogue_length = dialogues.length;
    let random_num = Math.floor(Math.random() * dialogue_length);
    console.log("Random Number is : " + random_num);
    console.log(dialogues[random_num].dialogue);
    setRandom(random_num);
  };

  return (
    <div className="main">

      <div className="header">
        <h1>🔥Bangla Pickup Lines🔥</h1>
        <div className="all-buttons">
          <div className="get-one-button">
            <Button
              onClick={getRandomDialogue}
              type="submit"
              variant="primary"
              size="lg"
            >
              Get One Pickup Line ❤️
            </Button>


          </div>
          <div className="song-buttons"></div>
        </div>
      </div>
      {/* {dialogues.map((item) => item.dialogue.map((line) => <h1>{line}</h1>))} */}

      <div className="ripon-data">
        {dialogues[random].dialogue.map((item) => (
          <h1 className="display">{item}</h1>
        ))}
      </div>
     
    </div>
  );
}

export default App;
